// components/ui/Content/ChartComponent3.tsx
import React from 'react';

import {
  ChartContainer,
  ChartLegend,
  ChartTooltip,
  ChartTooltipContent
} from '@/components/ui/chart';

import ChartComponent from './ChartsComponet';
import {
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  XAxis,
  YAxis
} from 'recharts';

const ChartComponent3: React.FC = () => {
  const chartData3 = {
    title: 'Impact of Biotech Innovations on Healthcare',
    source: 'Sources: FDA, WHO, BioCentury'
  };

  // Prepare the data for the chart
  const data = [
    { year: '2013', newTherapies: 5, livesSaved: 1, diseasesTargeted: 10 },
    { year: '2014', newTherapies: 8, livesSaved: 1.5, diseasesTargeted: 15 },
    { year: '2015', newTherapies: 10, livesSaved: 2, diseasesTargeted: 20 },
    { year: '2016', newTherapies: 12, livesSaved: 2.5, diseasesTargeted: 25 },
    { year: '2017', newTherapies: 15, livesSaved: 3, diseasesTargeted: 30 },
    { year: '2018', newTherapies: 18, livesSaved: 3.5, diseasesTargeted: 35 },
    { year: '2019', newTherapies: 20, livesSaved: 4, diseasesTargeted: 40 },
    { year: '2020', newTherapies: 22, livesSaved: 4.5, diseasesTargeted: 45 },
    { year: '2021', newTherapies: 25, livesSaved: 5, diseasesTargeted: 50 },
    { year: '2022', newTherapies: 28, livesSaved: 5.5, diseasesTargeted: 55 },
    { year: '2023', newTherapies: 32, livesSaved: 6, diseasesTargeted: 60 },
    { year: '2024', newTherapies: 36, livesSaved: 6.5, diseasesTargeted: 65 },
    { year: '2025', newTherapies: 42, livesSaved: 7.5, diseasesTargeted: 75 },
    { year: '2026', newTherapies: 50, livesSaved: 9, diseasesTargeted: 90 }
  ];

  // Create the chart as a React element
  const chart = (
    <ChartContainer
      config={{
        'New Therapies Approved': {
          label: 'New Therapies Approved',
          color: '#80ace4'
        },
        'Lives Saved (Millions)': {
          label: 'Lives Saved (Millions)',
          color: '#b580e4'
        },
        'Diseases Targeted': { label: 'Diseases Targeted', color: '#82e482' }
      }}>
      <BarChart
        data={data}
        margin={{ top: 0, left: -20, right: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray='3 3' />
        <XAxis dataKey='year' />
        <YAxis />
        <ChartTooltip content={(props) => <ChartTooltipContent {...props} />} />
        <ChartLegend verticalAlign='top' />
        <Bar
          dataKey='newTherapies'
          fill='#80ace4'
          name='New Therapies Approved'
        />
        <Bar
          dataKey='livesSaved'
          fill='#b580e4'
          name='Lives Saved (Millions)'
        />
        <Bar
          dataKey='diseasesTargeted'
          fill='#82e482'
          name='Diseases Targeted'>
          <LabelList
            dataKey='diseasesTargeted'
            position='top'
          />
        </Bar>
      </BarChart>
    </ChartContainer>
  );

  return (
    <ChartComponent
      data={chartData3} // Pass the data with title and source
      chart={chart} // Pass the chart as a React element
    />
  );
};

export default ChartComponent3;
